import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useHighContrastStore = defineStore('highContrastStore', () => {
  const highContrastOn = ref<boolean>(false);

  return { highContrastOn };
});
